import { AnyAction } from 'redux';
import { InvoiceNumberSequence, InvoiceNumberSequenceSupplier } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';

import {
    CREATE_INVOICE_NUMBER_SEQUENCE,
    CREATE_INVOICE_NUMBER_SEQUENCE_SUCCESS,
    DELETE_INVOICE_NUMBER_SEQUENCE_SUCCESS,
    FETCH_ALL_INVOICE_NUMBER_SEQUENCE_SUCCESS,
    FETCH_INVOICE_NUMBER_SEQUENCE,
    FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_SUCCESS,
    FETCH_INVOICE_NUMBER_SEQUENCE_FAILED,
    FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_SUCCESS,
    FETCH_INVOICE_NUMBER_SEQUENCE_SUCCESS,
    FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY,
    FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_ERROR,
    FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_SUCCESS,
    INVOICE_NUMBER_SEQUENCE_ERROR,
    UPDATE_INVOICE_NUMBER_SEQUENCE,
    UPDATE_INVOICE_NUMBER_SEQUENCE_SUCCESS,
} from './invoice-number-sequence-actions';
import { Prefix } from '../../../../../common/models/prefix';

export interface InvoiceNumberSequenceReducerState {
    invoiceNumberSequences: PaginatedResponse<InvoiceNumberSequence>;
    invoiceNumberSequencesAll: InvoiceNumberSequence[];
    invoiceNumberSequenceHistory: Prefix[];
    invoiceNumberSequenceSupplierHistory: Prefix[];
    suppliers: InvoiceNumberSequenceSupplier[];
    formError?: string;
    requesting: boolean;
}

export const invoiceNumberSequenceRatesReducerState: InvoiceNumberSequenceReducerState = {
    invoiceNumberSequences: { items: [], limit: 10, page: 0, total: 0 },
    invoiceNumberSequencesAll: [],
    invoiceNumberSequenceHistory: [],
    invoiceNumberSequenceSupplierHistory: [],
    suppliers: [],
    requesting: false,
};

export const invoiceNumberSequenceReducer = (
    state: InvoiceNumberSequenceReducerState = invoiceNumberSequenceRatesReducerState,
    action: AnyAction
): InvoiceNumberSequenceReducerState => {
    const { type } = action;

    switch (type) {
        case FETCH_INVOICE_NUMBER_SEQUENCE: {
            return {
                ...state,
                requesting: true,
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_SUCCESS: {
            return {
                ...state,
                invoiceNumberSequences: action['invoiceNumberSequences'],
                requesting: false,
            };
        }

        case FETCH_ALL_INVOICE_NUMBER_SEQUENCE_SUCCESS: {
            return {
                ...state,
                invoiceNumberSequencesAll: action['invoiceNumberSequencesAll'],
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY: {
            return {
                ...state,
                requesting: true,
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_SUCCESS: {
            return {
                ...state,
                invoiceNumberSequenceSupplierHistory: action['invoiceNumberSequenceHistory'],
                requesting: false,
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_SUPPLIER_HISTORY_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_FAILED: {
            return {
                ...state,
                requesting: false,
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_AVAILABLE_SUPPLIERS_SUCCESS: {
            return {
                ...state,
                suppliers: action['suppliers'],
            };
        }

        case UPDATE_INVOICE_NUMBER_SEQUENCE:
        case CREATE_INVOICE_NUMBER_SEQUENCE: {
            return {
                ...state,
                formError: undefined,
            };
        }

        case CREATE_INVOICE_NUMBER_SEQUENCE_SUCCESS: {
            return {
                ...state,
                invoiceNumberSequences: {
                    ...state.invoiceNumberSequences,
                    items: [action['invoiceNumberSequence'], ...state.invoiceNumberSequences.items],
                    total: state.invoiceNumberSequences.total + 1,
                },
            };
        }

        case UPDATE_INVOICE_NUMBER_SEQUENCE_SUCCESS: {
            const updatedSequence = action['invoiceNumberSequence'];

            return {
                ...state,
                invoiceNumberSequences: {
                    ...state.invoiceNumberSequences,
                    items: state.invoiceNumberSequences.items.map(invoiceNumberSequence =>
                        invoiceNumberSequence.id === updatedSequence.id ? updatedSequence : invoiceNumberSequence
                    ),
                },
            };
        }

        case DELETE_INVOICE_NUMBER_SEQUENCE_SUCCESS: {
            return {
                ...state,
                invoiceNumberSequences: {
                    ...state.invoiceNumberSequences,
                    items: state.invoiceNumberSequences.items.filter(
                        invoiceNumberSequence => invoiceNumberSequence.id !== action['invoiceNumberSequenceId']
                    ),
                    total: state.invoiceNumberSequences.total - 1,
                },
            };
        }

        case FETCH_INVOICE_NUMBER_SEQUENCE_HISTORY_SUCCESS: {
            return {
                ...state,
                invoiceNumberSequenceHistory: action['invoiceNumberSequenceHistory'],
            };
        }

        case INVOICE_NUMBER_SEQUENCE_ERROR: {
            return {
                ...state,
                formError: action['errorMessage'],
            };
        }

        default: {
            return state;
        }
    }
};
